export default __webpack_public_path__ + "static/media/Business-HR-Solutions-Logo.ba75210d.png";